<template>
  <div v-loading="loading">
    <el-table
      v-if="tableConfig"
      :key="tableKey"
      :data="packings.data"
      style="width: 100%"
      row-key="id"
      @sort-change="handleSortChange"
    >
      <component
        :is="column.value"
        v-for="column in tableConfig.columns"
        :key="column.value"
      />
      <el-table-column
        fixed="right"
        label=""
        width="60"
        style="text-align: right;"
      >
        <template
          slot="header"
          slot-scope="scope"
        >
          <table-settings
            v-if="tableConfig"
            :config="tableConfig"
            :allcolumns="allColumns"
            :labels="labels"
            storeModule="packing"
            :options="['settings']"
          />
        </template>
         <template
          slot-scope="scope"
        >
          <Actions :packing="scope.row" />
        </template>
      </el-table-column>
    </el-table>
    <div class="el-card-footer">
      <el-pagination
        background
        :current-page.sync="currentPage"
        :page-sizes="[20, 50, 100, 200]"
        :page-size="packings.per_page"
        layout="total, prev, pager, next"
        :total="packings.total"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
  import TableSettings from '../../TableSettings';
  import columns, { allColumns, labels } from './columns';
  import Actions from './Actions';

  export default {
    components: {
      Actions,
      TableSettings,
      ...columns,
    },
    data() {
      return {
        labels,
        allColumns,
        tableKey: 0,
        currentPage: 1,
        currentSort: {
          prop: 'created_at',
          order: 'descending',
        },
      };
    },
    computed: {
      packings() {
        return this.$store.getters['packing/packings'];
      },
      tableConfig() {
        return JSON.parse(JSON.stringify(this.$store.getters['packing/tableConfig']));
      },
      loading() {
        return this.$store.getters['packing/loading'];
      },
    },
    watch: {
      tableConfig() {
        this.tableKey++;
      },
    },
    methods: {
      handleCurrentChange(val) {
        this.$store.commit('packing/setCurrentPage', val);
        this.$store.dispatch('packing/fetchAll');
      },
      handleSortChange({ column, prop, order }) {
        this.$store.commit('packing/setSorting', { prop, order });
        this.$store.dispatch('packing/fetchAll');
      },
    },
    async mounted() {
      this.$store.commit('packing/setCurrentPage', this.currentPage);
      this.$store.commit('packing/setSorting', this.currentSort);
      await this.$store.dispatch('packing/fetchAll');
    },
  };
</script>

